import React from 'react';
import { User, Clock, Info, CheckSquare, AlertTriangle, Trash2, Phone, Mail } from 'react-feather';

function DailyAppointmentsList({ appointments, date, onStatusChange, onDelete }) {
  // Format date for display
  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // Get status color class
  const getStatusColor = (status) => {
    switch(status) {
      case 'confirmed':
        return 'status-confirmed';
      case 'cancelled':
        return 'status-cancelled';
      default:
        return 'status-pending';
    }
  };

  return (
    <div className="daily-appointments">
      <h3 className="daily-appointments-title">
        <span className="date-icon">📅</span> {formattedDate}
      </h3>
      
      {appointments.length === 0 ? (
        <p className="no-appointments">No appointments scheduled for this date.</p>
      ) : (
        <div className="appointments-list">
          {appointments.map((appointment) => (
            <div 
              key={appointment.id} 
              className={`appointment-item ${getStatusColor(appointment.status)}`}
            >
              <div className="appointment-main-info">
                <div className="appointment-time">
                  <Clock size={14} /> {appointment.time}
                </div>
                <div className="appointment-name">
                  <User size={14} /> {appointment.name}
                </div>
                <div className="appointment-service">
                  <Info size={14} /> {appointment.service}
                </div>
                <div className="appointment-contact">
                  <Mail size={14} /> {appointment.email}
                </div>
                <div className="appointment-contact">
                  <Phone size={14} /> {appointment.phone}
                </div>
              </div>
              
              <div className="appointment-actions">
                <button 
                  className="action-button confirm" 
                  onClick={() => onStatusChange(appointment.id, 'confirmed')}
                  aria-label="Confirm appointment"
                >
                  <CheckSquare size={16} />
                </button>
                <button 
                  className="action-button cancel" 
                  onClick={() => onStatusChange(appointment.id, 'cancelled')}
                  aria-label="Cancel appointment"
                >
                  <AlertTriangle size={16} />
                </button>
                <button 
                  className="action-button delete" 
                  onClick={() => onDelete(appointment.id)}
                  aria-label="Delete appointment"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DailyAppointmentsList;